export const generateUri = (name) => {
    return name
        .toLowerCase()
        .normalize('NFD') // Normalize to decomposed form
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        .replace(/[^a-z0-9-]/g, '-') // Replace any non-alphanumeric with hyphen
        .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
        .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
};

export const validateUri = (uri) => {
    return !/\s/.test(uri) && /^[a-z0-9-]+$/.test(uri);
}; 